import React, { useEffect, useState } from "react";
import "./ContentPlanDrawer.css";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox, Modal, Row, Col, Card, Divider, Space, Button, notification, message, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { fetchWrapper } from "../../helpers";
import { useNavigate } from "react-router-dom";
import { daysOfWeek } from "../../constants/daysOfWeek";

const baseUrl = `${process.env.REACT_APP_API_URL}`;

function ContentPlanDrawer({
                               open,
                               close,
                               onOk,
                               loadingCreate,
                               activeWeek,
                               socialNetworks,
                               handleChangeSocialNetworks,
                               currentWeekSnCreated,
                               selectedGeneratingWeekDays,
                               setSelectedGeneratingWeekDays,
                           }) {
    const [localUser, setLocalUser] = useState(JSON.parse(localStorage.getItem("user")));
    const { t } = useTranslation();
    const [toggles, setToggles] = useState({});
    const [frequency, setFrequency] = useState(7);
    const [strategy, setStrategy] = useState(false);
    const [notificationApi, notificationContextHolder] = notification.useNotification();
    const navigate = useNavigate();
    const blocks = useSelector((obj) => obj.strategy.blocks);

    const openNotificationLinkedIn = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate("/profile")}>
                    {t("profile.linkAccount")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: t("contentPlan.tokenError"),
            btn,
            key,
            onClose: close,
        });
    };

    const handleToggle = (key) => setToggles({ ...toggles, [key]: !toggles[key] });

    const submit = () => {
        if (!socialNetworks) {
            openNotificationLinkedIn();
        } else {
            const filteredToogles = Object.keys(toggles).filter((i) => toggles[i]);
            onOk({ contentBlocks: filteredToogles, socialNetworks: socialNetworks.split(","), frequency });
        }
    };

    useEffect(() => {
        fetchWrapper.get(`${baseUrl}/strategy/actual/`).then((res) => {
            if (res[0] != null) setStrategy(true);
        });
    }, []);

    return (
        <>
            {notificationContextHolder}
            <Modal
                onCancel={close}
                open={open}
                footer={
                    <Space>
                        <Button onClick={close}>{t("functions.close")}</Button>
                        <Button
                            type="primary"
                            disabled={loadingCreate || !socialNetworks}
                            loading={loadingCreate}
                            onClick={submit}
                        >
                            {t("functions.generate")}
                        </Button>
                    </Space>
                }
                title={t("contentPlan.header")}
            >
                {/* Networks */}
                <Row
                    gutter={[12, 12]}
                    justify="center"
                    style={{ borderBottom: "1px solid #E9D7FE", paddingBottom: 12, marginBottom: 12 }}
                >
                    {!currentWeekSnCreated.linkedin && (
                        <Col xs={8}>
                            <Card
                                size="small"
                                hoverable
                                onClick={() => handleChangeSocialNetworks("LinkedIn")}
                                bodyStyle={{ textAlign: "center", opacity: socialNetworks?.includes("LinkedIn") ? 1 : 0.4 }}
                            >
                                <img
                                    loading="lazy"
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/d25408c5dff59b86cb5e75674b2a798a87cd455bde0adf0ceb8c9a670d1405e8?apiKey=300ff06bbf3a4f5c9c73ca7577720bf1&"
                                    className="self-center w-6 aspect-square"
                                    alt=""
                                />
                                <div className="mt-1">LinkedIn</div>
                            </Card>
                        </Col>
                    )}

                    {!currentWeekSnCreated.facebook && (
                        <Col xs={8} className={`${process.env.REACT_APP_IS_HIDE_FACEBOOK === "true" ? "hidden" : ""}`}>
                            <Card
                                size="small"
                                hoverable
                                onClick={() => handleChangeSocialNetworks("Facebook")}
                                bodyStyle={{ textAlign: "center", opacity: socialNetworks?.includes("Facebook") ? 1 : 0.4 }}
                            >
                                <img
                                    loading="lazy"
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/f8432315b7e3752ab28ffd9571f771342eef6b676c1f20e4b8a5e6ee48c70349?apiKey=300ff06bbf3a4f5c9c73ca7577720bf1&"
                                    className="self-center w-6 aspect-square"
                                    alt=""
                                />
                                <div className="mt-1">Facebook</div>
                            </Card>
                        </Col>
                    )}

                    {!currentWeekSnCreated.instagram && (
                        <Col xs={8}>
                            <Card
                                size="small"
                                hoverable
                                onClick={() => handleChangeSocialNetworks("Instagram")}
                                bodyStyle={{ textAlign: "center", opacity: socialNetworks?.includes("Instagram") ? 1 : 0.4 }}
                            >
                                <img
                                    loading="lazy"
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/497038a4df4615b7ef35db19c49364c0fdcd7e3749f9681fe807b55de2426e88?apiKey=300ff06bbf3a4f5c9c73ca7577720bf1&"
                                    className="self-center w-6 aspect-square"
                                    alt=""
                                />
                                <div className="mt-1">Instagram</div>
                            </Card>
                        </Col>
                    )}
                </Row>

                {/* Weekdays */}
                <Typography.Title level={5} style={{ textAlign: "center", marginBottom: 8 }}>
                    {t("contentPlan.selectWeekDaysTitle")}
                </Typography.Title>
                <Row justify="center">
                    <Space direction="vertical">
                        {daysOfWeek.map((day) => (
                            <Checkbox
                                key={day}
                                checked={selectedGeneratingWeekDays?.includes(day)}
                                onChange={(e) => {
                                    setSelectedGeneratingWeekDays(
                                        e.target.checked
                                            ? [...selectedGeneratingWeekDays, day]
                                            : selectedGeneratingWeekDays.filter((d) => d !== day)
                                    );
                                }}
                            >
                                {t(`weekDays.${day}`)}
                            </Checkbox>
                        ))}
                    </Space>
                </Row>

                {(localUser?.strategiesCount < 5 ||
                    (activeWeek === 3 && localUser?.strategiesCount < 15)) && (
                    <Typography.Title level={5} style={{ textAlign: "center", marginTop: 16 }}>
                        {t("contentPlan.needSurveyText")}
                    </Typography.Title>
                )}
            </Modal>
        </>
    );
}

export default ContentPlanDrawer;
